import addToCalendar from "../src/features/add-to-calendar";
import exportComponentsToRails from "../src/shared/utilities/exportComponentsToRails";

exportComponentsToRails("addToCalendar", {
  addToCalendar
});
